import { useReducedMotion } from 'motion/react';
import { type ReactNode, useState } from 'react';
import { cn } from '@/lib/utils';

/** After the title starts: 380 ms, then 90 ms per block (NEWS-08). */
const FIRST_BLOCK_MS = 380;
export const RISE_STAGGER_MS = 90;

/**
 * A block of the slide fading up in order (`index` 0, 1, 2…, NEWS-08);
 * already in place under reduced motion (NEWS-09). The animation is dropped
 * once it ends: a filled opacity animation would stop the glass cards
 * inside from blurring the torus behind them.
 */
export function Rise({
  index,
  className,
  children,
}: {
  index: number;
  className?: string;
  children: ReactNode;
}) {
  const reduceMotion = useReducedMotion() ?? false;
  const [done, setDone] = useState(false);
  const animating = !reduceMotion && !done;

  return (
    <div
      data-testid="rise"
      className={cn(animating && 'animate-rise', className)}
      style={
        animating
          ? { animationDelay: `${FIRST_BLOCK_MS + index * RISE_STAGGER_MS}ms` }
          : undefined
      }
      onAnimationEnd={(event) => {
        if (event.target === event.currentTarget) setDone(true);
      }}
    >
      {children}
    </div>
  );
}
